export default function JaNeinFilter({ column: {filterValue, setFilter, id}, data}) {
    const newFilter = event => {
        if (event.target.value === 'all') {
            setFilter(undefined);
        } else {
            setFilter(event.target.value)
        }
    }

    return(
        <select onChange={newFilter} value={filterValue?filterValue:undefined} className="such-input">
            <option value='all'>---Alles---</option>
            {[...new Set (data.map(item => item[id]))]
                .map(value => {
                    return (
                      <option key={value} value={value ? "ja" : "nein"}>
                        {value ? "ja" : "nein"}
                      </option>
                    );
                  })}
        </select>
    )
}